import { DialogContentText, styled } from "@mui/material";
import { ReactElement } from "react";

import { CampaignStatus } from "~frontend/__generated__/graphql";
import { CampaignForEditor } from "~frontend/routes/subaccounts/campaignEditor/types";
import { CampaignWithSuppressionData } from "~frontend/routes/types";
import { plural } from "~frontend/util/plural";

const NoBulletList = styled("ul")({
  listStyleType: "none",
});

export default function JobComplete({
  job,
  campaign,
}: {
  job: NonNullable<CampaignForEditor["createSuppressionsFromListJob"]>;
  campaign: CampaignWithSuppressionData;
}): ReactElement {
  if (!job.result) {
    return <></>;
  }

  const { listId } = job.result;
  const list = campaign.suppressionLists.find(l => l.id === listId);
  if (!list) {
    return <></>;
  }

  return (
    <DialogContentText>
      <h3>Suppressed {plural(list.suppressedCount, "contact", "contacts")}</h3>
      <NoBulletList>
        <li>
          {plural(list.rowCount)} uploaded from {list.upload.fileName}
        </li>
        {list.invalidCount > 0 && (
          <li>
            {plural(
              list.invalidCount,
              "invalid phone number",
              "invalid phone numbers"
            )}{" "}
            skipped
          </li>
        )}
        {list.duplicateCount > 0 && (
          <li>
            {plural(
              list.duplicateCount,
              "duplicate phone number",
              "duplicate phone numbers"
            )}{" "}
            skipped
          </li>
        )}
        {list.notInCampaignCount > 0 && (
          <li>
            {plural(list.notInCampaignCount)} skipped because they are not in
            the campaign
            {campaign.status !== CampaignStatus.Draft &&
              " or have already been messaged"}
          </li>
        )}
      </NoBulletList>
    </DialogContentText>
  );
}
